import React from "react";
import {
  Row,
  Col,
  Form,
  Dropdown,
  Button,
  InputGroup,
  Badge,
} from "react-bootstrap";
import { FaFilter, FaSearch } from "react-icons/fa";
import { IoSettingsSharp } from "react-icons/io5";

const TableToolbar = ({
  searchQuery,
  setSearchQuery,
  tableData,
  rowsPerPage,
  setRowsPerPage,
  headersState,
  setHeadersState,
  showFilters,
  setShowFilters,
  isFiter,
}) => {
  return (
    <Row className="align-items-center mb-3 g-2">
      {/* 🔍 Search Bar */}
      <Col xs={12} md={4} className="mb-2 mb-md-0">
        <InputGroup>
          <InputGroup.Text className="bg-white">
            <FaSearch className="text-muted" />
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Search records..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </InputGroup>
      </Col>

      {/* 📊 Record Count */}
      <Col xs={12} md="auto">
        <Badge bg="info" text="white" className="px-3 py-2 fs-6 shadow-sm">
          {tableData.length} Records
        </Badge>
      </Col>

      {/* ⚙️ Right-side Controls */}
      <Col
        xs={12}
        md="auto"
        className="ms-md-auto d-flex flex-wrap justify-content-center justify-content-md-end gap-2"
      >
        {/* Filter Button */}
        {isFiter >0 && (
          <Button
            variant={showFilters ? "primary" : "outline-secondary"}
            className="d-flex align-items-center gap-1 shadow-sm"
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <FaFilter /> {showFilters ? "Hide Filters" : "Filters"}
          </Button>
        )}

        {/* Rows per page */}
        <InputGroup size="sm" className="w-auto shadow-sm">
          <Form.Select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(+e.target.value)}
          >
            {[10, 25, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </Form.Select>
          <InputGroup.Text>per page</InputGroup.Text>
        </InputGroup>

        {/* Column settings */}
        <Dropdown align="end">
          <Dropdown.Toggle
            as="span"
            className="icon-default cursor-pointer p-2 rounded shadow-sm bg-light"
            role="button"
          >
            <IoSettingsSharp className="fs-5 text-secondary" />
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="p-2"
            style={{ maxHeight: 300, overflowY: "auto", width: 220 }}
          >
            <h6 className="dropdown-header text-muted">Visible Columns</h6>
            {headersState
              .filter((head) => !head.key.endsWith("__r"))
              .map((head) => (
                <Form.Check
                  key={head.key} // use unique key instead of index
                  type="checkbox"
                  label={head.label}
                  checked={head.show}
                  className="mb-1"
                  onChange={(e) => {
                    // update the original headersState by key
                    setHeadersState((prev) =>
                      prev.map((h) =>
                        h.key === head.key
                          ? { ...h, show: e.target.checked }
                          : h
                      )
                    );
                  }}
                />
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default TableToolbar;
